import { render, staticRenderFns } from "./TrainingPlans.vue?vue&type=template&id=5af906f2"
import script from "./TrainingPlans.vue?vue&type=script&lang=js"
export * from "./TrainingPlans.vue?vue&type=script&lang=js"
import style0 from "./TrainingPlans.vue?vue&type=style&index=0&id=5af906f2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports